import React from "react"
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {assignmentEmployeeAction, assignmentEmployeeActionUpload, selectAssignment} from "../../actions/actions";
import Loading from "../../../../common/js/components/loading";
import {handleApiResponse} from "../../../../common/js/crud-actions";
import {push} from "connected-react-router";
import {clearNotifications, setNotification} from "../../../../common/js/notifications/notifications-actions";
import ContentUnitShow from "../../../../common/js/components/content-units/show";
import Notifications from "../../../../common/js/notifications/components/notifications";

class LifeAtInnogyEdit extends React.Component {
    componentWillMount() {
        const instanceId = this.props.match.params.id;
        this.props.selectAssignment('api/v1', instanceId);
    }

    markAsDone = () => {
        const instanceId = this.props.match.params.id;
        let promise = this.props.assignmentEmployeeAction('api/v1', instanceId, { execute: 'mark_as_done' });
        handleApiResponse('ASSIGNMENT','ACTION', promise,
            (response) => {
                this.props.push('/dashboard/');
                this.props.setNotification('success', this.props.intl.formatMessage({id: "app.content_units.mark_as_done.success"}));
            },
            (response) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            },
            (response) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            });
    };

    render() {
        let selected = this.props.assignments.selected;

        if (!selected)
            return (<Loading main={true}/>);

        return (
            <div className='main-content'>
                <Notifications container={true} app='candidate'/>
                <ContentUnitShow
                    assignment={selected}
                    markAsDone={this.markAsDone}
                    assignmentAction={this.props.assignmentEmployeeAction}
                    assignmentUpload={this.props.assignmentEmployeeActionUpload}
                    setNotification={this.props.setNotification}
                    selectAssignment={this.props.selectAssignment}
                    clearNotifications={this.props.clearNotifications}
                    constants={this.props.constants}
                    push={this.props.push}
                />
                <div className='container pb-5'>
                    <hr/>
                    <Link to='/life-at-innogy' className='btn btn-gasnet-green'><FormattedMessage id='app.content_units.actions.list'/></Link>
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        assignments: state.assignments,
        constants: state.constants
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        selectAssignment: selectAssignment,
        assignmentEmployeeAction: assignmentEmployeeAction,
        assignmentEmployeeActionUpload: assignmentEmployeeActionUpload,
        push: push,
        setNotification: setNotification,
        clearNotifications: clearNotifications
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(LifeAtInnogyEdit));
